import SelectDays from "@/components/selectDays/selectDays.vue";
import CalendarInput from "@/components/calendarInput/calendarInput.vue";
import ConfirmChangeDatesModal from "@/components/modal/confirmChangeDatesModal.vue";
import { createNamespacedHelpers } from "vuex";
import moment from "moment";

const { mapActions: userActions } = createNamespacedHelpers("user"),
	{ mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	components: {
		SelectDays,
		CalendarInput,
		ConfirmChangeDatesModal,
	},

	props: {
		edit: {
			type: Boolean,
			default: false,
		},
		editDate: {
			type: Object,
			required: false,
		},
	},

	data() {
		return {
			days: this.edit ? this.editDate.days : [],
			startDate: this.edit ? new Date(this.editDate.start_date) : new Date(),
			showConfirmModal: false,
			error: false,
		};
	},

	methods: {
		onConfirmSave,

		...userActions(["addClosingDate", "editClosingDate", "verifyStartDate"]),

		...userGetters(["openClosedDays"]),
	},

	watch: {
		startDate(value) {
			// Check if start date is the same as an already configured closed days
			let sameStartDate = this.openClosedDays();
			sameStartDate = sameStartDate.filter(
				(closedDay) =>
					((this.edit && closedDay.__key !== this.editDate.__key) || !this.edit) &&
					moment(closedDay.start_date).format("YYYY-MM-DD") === moment(value).format("YYYY-MM-DD")
			);
			this.error = sameStartDate.length > 0;
		},
	},
};

function onConfirmSave() {
	if (this.edit) {
		this.editClosingDate({
			__key: this.editDate.__key,
			startDate: moment(this.startDate).format("YYYY-MM-DD"),
			days: this.days,
		});
	} else {
		this.addClosingDate({
			startDate: moment(this.startDate).format("YYYY-MM-DD"),
			days: this.days,
		});
	}
	this.$emit("save");
}
